import React from "react";
import { css } from "@emotion/react";
import { Font, FieldLabel } from "@moneyforward/mfx_biz_react_components";
import { useIsSpMode } from "@/hooks";
import { COMPANY_OPTIONS_STAFF_COUNTS } from "@/libs/constants";
import { FormErrorMessage, FormSelectBox } from "@/components/molecules";

type Props = {
  name: string;
  labelRequired: boolean;
};

export const StaffCountFormField = (props: Props) => {
  const isSpMode = useIsSpMode();
  return (
    <div css={!isSpMode ? container : {}}>
      <div css={labelWrapper}>
        <FieldLabel
          isRequired={props.labelRequired}
          helpMessage={
            <Font variant="s">
              役員や正規雇用の方のみの人数を入力してください。
            </Font>
          }
        >
          従業員数
        </FieldLabel>
      </div>
      <div css={inputWrapper}>
        <div css={fieldWrapper}>
          <FormSelectBox
            name={props.name}
            placeholder={"未選択"}
            options={COMPANY_OPTIONS_STAFF_COUNTS}
          />
          <FormErrorMessage name={props.name} />
        </div>
        <div css={unitWrapper}>
          <Font variant="m">名</Font>
        </div>
      </div>
    </div>
  );
};

const container = css({
  display: "flex",
});

const labelWrapper = css({
  width: "160px",
  marginRight: "16px",
  paddingTop: "10px",
  paddingBottom: "4px",
});

const inputWrapper = css({
  display: "flex",
  alignItems: "center",
});

const fieldWrapper = css({
  maxWidth: "196px",
});

const unitWrapper = css({
  marginLeft: "16px",
});
